export default __webpack_public_path__ + "static/media/jenny-roderick-untermyergarden-palma-wedding-75_tn.fc121f63.jpg";